import React from 'react';
interface ButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'small' | 'medium' | 'large';
  className?: string;
  onClick?: () => void;
  type?: 'button' | 'submit' | 'reset';
}
export const Button = ({
  children,
  variant = 'primary',
  size = 'medium',
  className = '',
  onClick,
  type = 'button'
}: ButtonProps) => {
  const baseClasses = 'inline-flex items-center justify-center transition-colors font-medium border-2 rounded-md';
  const variantClasses = {
    primary: 'bg-primary text-white border-primary hover:bg-primary-light',
    secondary: 'bg-secondary text-white border-secondary hover:bg-secondary-light',
    outline: 'bg-transparent text-primary border-primary hover:bg-primary/5'
  };
  const sizeClasses = {
    small: 'px-3 py-1 text-sm',
    medium: 'px-4 py-2',
    large: 'px-6 py-3 text-lg'
  };
  return <button type={type} className={`${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${className}`} onClick={onClick} data-id="element-1018">
      {children}
    </button>;
};